import { render, staticRenderFns } from "./P0109.vue?vue&type=template&id=64406f3b&scoped=true&"
import script from "./P0109.vue?vue&type=script&lang=ts&"
export * from "./P0109.vue?vue&type=script&lang=ts&"
import style0 from "./P0109.vue?vue&type=style&index=0&id=64406f3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64406f3b",
  null
  
)

export default component.exports